import React, { useEffect, useState } from "react";
import { getPurchaseOrder } from "../../actions/project-management.action";
import idx from "idx";
import { numberFormat } from "../../util/currency-formatter";
import moment from 'moment';
import { Modal, Button, Table } from 'react-bootstrap';
import { useDispatch } from "react-redux";
import { roundValue } from "src/util/decimal-utils";

function ViewWOModal({ show, onHide, woId }) {
    const [WO, setWO] = useState({});
    const [vendorName, setVendorName] = useState("");
    const [materialItems, setMaterialItems] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [loading, setLoading] = useState(true);

    const dispatch = useDispatch();

    useEffect(() => {
        if (woId && show) {
            getWO();
        }
    }, [woId, show]);

    const getWO = async () => {
        setLoading(true);
        try {
            const query = `?woId=${woId}`;
            let res = await dispatch(getPurchaseOrder(query));
            setWO(res);
            setVendorName(idx(res, (_) => _.vendor.business_name) || "");
            setMaterialItems(idx(res, (_) => _.items) || []);

            const attachment = res && res.attachment && res.attachment.map(item => {
                return (
                    <div key={item.id || item.name} className="attachedFiles">
                        <p style={{ margin: '0 10px 0 0' }}>{item.name}</p>
                    </div>
                )
            });
            setAttachments(attachment);
        } catch (error) {
            console.error("Error fetching Work Order details:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="work-order-modal"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="work-order-modal" className='brand-color-3'>
                    Work Order Details
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? (
                    <div className="text-center p-4">Loading work order details...</div>
                ) : (
                    <>
                        <div className="row">
                            <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>Work Order No</label>
                                    {/* fId is the WO number with project prefix and Suffix if null then default to wo Number*/}
                                    <p>{WO.f_id || WO.id}</p>
                                </div>
                            </div>
                            {idx(WO, _ => _.rfq.description) && (
                                <div className="col-lg-4 mt-3">
                                    <div className="view-block">
                                        <label>Description</label>
                                        <p>{idx(WO, _ => _.rfq.description)}</p>
                                    </div>
                                </div>
                            )}
                            <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>Vendor Type</label>
                                    <p>Contractor</p>
                                </div>
                            </div>
                            <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>Vendor</label>
                                    <p>{vendorName}</p>
                                </div>
                            </div>
                            {idx(WO, _ => _.quotation.id) && (
                                <div className="col-4 mt-3">
                                    <div className="view-block">
                                        <label>Quote Request No</label>
                                        <p>{idx(WO, _ => _.quotation.id)}</p>
                                    </div>
                                </div>
                            )}
                            {WO.quoteNo && (
                                <div className="col-4 mt-3">
                                    <div className="view-block">
                                        <label>Quote No</label>
                                        <p>{WO.quoteNo}</p>
                                    </div>
                                </div>
                            )}
                            <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>Delivery Option</label>
                                    <p>{idx(WO, (_) => _.deliveryOption) || "-"}</p>
                                </div>
                            </div>
                            <div className="col-4 mt-3">
                                <div className="view-block">
                                    <label>Delivery Date</label>
                                    <p>{idx(WO, (_) => _.deliveryDate) ? moment(idx(WO, (_) => _.deliveryDate)).format('DD/MM/YYYY') : "-"}</p>
                                </div>
                            </div>
                            <div className="col-lg-4 mt-3">
                                <div className="view-block">
                                    <label>Attachments</label>
                                    <p>{attachments}</p>
                                </div>
                            </div>
                            <div className="col-lg-12 mt-3">
                                <div className="view-block">
                                    <label>Notes</label>
                                    <p>{idx(WO, (_) => _.notes) || "-"}</p>
                                </div>
                            </div>
                        </div>

                        <div className="material-list-block mt-4">
                            <div className="table-responsive">
                                <Table bordered className="table-create table-material table-material-ch">
                                    <thead>
                                        <tr>
                                            <th>Tasks/Section</th>
                                            <th>Description</th>
                                            <th>Quote Submitted</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {WO.is_uploaded_cost ? (
                                            <tr>
                                                <td colSpan={3} className="text-center py-3" style={{ color: "#495057", fontWeight: "500" }}>
                                                    This is a virtual purchase order for direct cost attribution. Items are directly recorded on the vendor invoice.
                                                </td>
                                            </tr>
                                        ) : (
                                            materialItems.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.taskName}</td>
                                                    <td>{item.name || "-"}</td>
                                                    <td>${roundValue(item.total, 2)}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button className='btn-bg-brand-5 btn-border-none' onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ViewWOModal; 